import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import store from './store'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import Overlay from './components/Overlay.vue'
import FileBrowser from './components/filebrowser/index'
import PageClassSubjectAssignment from './pages/class-subject-assignment/index.vue'
import PageSubjects from './pages/subjects/index.vue'
import PageSubjectEdit from './pages/subjects/[id].vue'

Vue.use(VueCompositionAPI)

Vue.component('app', <any>App)
Vue.component('Overlay', <any>Overlay)
Vue.component('FileBrowser', <any>FileBrowser)
Vue.component('PageClassSubjectAssignment', <any>PageClassSubjectAssignment)
Vue.component('PageSubjects', <any>PageSubjects)
Vue.component('PageSubjectEdit', <any>PageSubjectEdit)

const app = new Vue({
    store,
    vuetify,
})

app.$mount('#app')
